import { Injectable, computed, inject, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SearchService, SearchServiceState } from 'app-shell-data';
import { ProductEntity } from 'products-data';

import { ProductFastSearchResults, ProductQuickSearchComponentStore } from 'product-quick-search-data';

@Injectable()
export class ProductQuickSearchService implements SearchService<ProductFastSearchResults> {
  private readonly _store = inject(ProductQuickSearchComponentStore);
  public readonly searchQuery = this._store.keyword;
  public readonly searchResults = computed(
    (): ProductFastSearchResults => ({
      byPartNumber: (this._store.byPartNumber() ?? []).filter((v): v is ProductEntity => !!v),
      byPartNumberMore: this._store.byPartNumber.hasMore(),
      byDescription: (this._store.byDescription() ?? []).filter((v): v is ProductEntity => !!v),
      byDescriptionMore: this._store.byDescription.hasMore(),
      byKeyword: (this._store.byKeyword() ?? []).filter((v): v is ProductEntity => !!v),
      byKeywordMore: this._store.byKeyword.hasMore(),
      byCrossReference: (this._store.byCrossReference() ?? []).filter((v): v is ProductEntity => !!v),
      byCrossReferenceMore: this._store.byCrossReference.hasMore(),
    }),
  );
  private readonly searchResults$ = toObservable(this.searchResults);

  public readonly searchResultCount = computed(() => {
    const results = this.searchResults();
    return (
      (results.byCrossReference?.length ?? 0) +
      (results.byDescription?.length ?? 0) +
      (results.byKeyword?.length ?? 0) +
      (results.byPartNumber?.length ?? 0)
    );
  });

  public readonly searchResultsMore = computed(() => ({
    byCrossReference: this._store.byCrossReference.hasMore(),
    byDescription: this._store.byDescription.hasMore(),
    byKeyword: this._store.byKeyword.hasMore(),
    byPartNumber: this._store.byPartNumber.hasMore(),
  }));

  public readonly searchState = signal(SearchServiceState.Idle).asReadonly();
  public readonly searchError = signal<any>(undefined).asReadonly();

  public search(value: string) {
    this._store.setKeyword(value);
  }
}
